import styles from './activityMeetup.module.css';
import CharCount from '../../../charCount/CharCount';
import { useState } from 'react';

const ActivityMeetup = ({ activityData, setActivityData }) => {
    const mapUrlPattern = /^https?:\/\/(?:www\.)?maps\.app\.goo\.gl\/([A-Za-z0-9_-]{11,17})(?:[\/?].*)?$/i;
    const [meetupCount, setMeetupCount] = useState(activityData.meetupLocation.length || 1);
    // Handle meetup input change
    const handleMeetup = (e, meetupIndex) => {
        const { name, value } = e.target;

        setActivityData((prev) => {
            const updatedMeetup = prev.meetupLocation.map((item, index) => {
                if (index !== meetupIndex) return item;

                return {
                    ...item,
                    [name]: value
                };
            });

            return {
                ...prev,
                meetupLocation: updatedMeetup
            };
        });
    };

    // Add meetup block
    const handleAddMeetup = () => {
        setActivityData((prev) => ({
            ...prev,
            meetupLocation: [
                ...(prev.meetupLocation || []),
                {
                    name: '',
                    location: ''
                }
            ]
        }));
    };

    // Delete meetup block
    const handleDeleteMeetup = () => {
        setActivityData((prev) => {
            if (prev.meetupLocation.length <= 1) {
                return prev;
            }

            return {
                ...prev,
                meetupLocation: prev.meetupLocation.slice(0, -1)
            };
        });
    };

    return (
        <div>
            <h2 className={styles.orgPackUpH2}>Meetup Location</h2>

            <div className={styles.orgPackUpSecDiv}>
                {activityData?.meetupLocation?.map((item, meetupIndex) => (
                    <div key={meetupIndex}>
                        <p className={styles.priceLabel}>Meetup {meetupIndex + 1}</p>

                        {/* Meetup Name */}
                        <div className={styles.priceInDiv}>
                            <label className={styles.priceLabel}>Meetup Point</label>

                            <div className={styles.priceInputDiv}>
                                <input
                                    type='text'
                                    name='name'
                                    value={activityData?.meetupLocation[meetupIndex]?.name}
                                    onChange={(e) => handleMeetup(e, meetupIndex)}
                                    placeholder='Ex- Indiranagar Bus stop (9:00 PM)'
                                    className={styles.priceInput}
                                />

                                <CharCount
                                    string={activityData?.meetupLocation[meetupIndex]?.name || ''}
                                    min={4}
                                    limit={30}
                                />
                            </div>
                        </div>

                        {/* Meetup Location */}
                        <div className={styles.priceInDiv}>
                            <label className={styles.priceLabel}>Google Location</label>

                            <div className={styles.priceInputDiv}>
                                <input
                                    type='text'
                                    name='location'
                                    value={activityData?.meetupLocation[meetupIndex]?.location}
                                    onChange={(e) => handleMeetup(e, meetupIndex)}
                                    placeholder='Google Maps URL'
                                    className={styles.priceInput}
                                />

                                <CharCount
                                    string={activityData?.meetupLocation[meetupIndex]?.location || ''}
                                    min={10}
                                    limit={300}
                                />
                            </div>
                        </div>
                    </div>
                ))}

                {/* Buttons */}
                <div className={`alignButtons ${styles.priceBtn}`}>
                    <button type='button' onClick={handleAddMeetup} className={styles.priceAddBtn}>
                        Add Meetup
                    </button>

                    <button
                        type='button'
                        onClick={handleDeleteMeetup}
                        className={styles.priceDelBtn}
                        disabled={activityData?.meetupLocation?.length <= 1}
                    >
                        Delete Meetup
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ActivityMeetup;
